import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const BatchCommentLimitDialog = ({ open, onClose, goToUpgrade }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box display="flex" alignItems="center" gap={1}>
                    <WarningAmberIcon color="warning" />
                    <Typography variant="h6" fontWeight="bold">
                        Batch Comment Limit Reached
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    You've reached your trial limit for <strong>Batch Subject Comment Generation</strong>.
                </Typography>
                
                <Box sx={{ 
                    p: 2, 
                    backgroundColor: '#e3f2fd', 
                    borderRadius: 2, 
                    border: '1px solid #bbdefb',
                    mb: 2 
                }}>
                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 'medium' }}>
                        💡 Alternative Option:
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        You can always create comments using the <strong>"Generate Comment For Single Student"</strong> feature if you have reached the limit for this feature.
                    </Typography>
                </Box>
                
                <Typography variant="body2" color="text.secondary">
                    Or upgrade to a premium plan for unlimited access to batch comment generation and more features.
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="primary">
                    Close
                </Button>
                <Button
                    onClick={() => {
                        onClose();
                        if (typeof goToUpgrade === "function") {
                            goToUpgrade();
                        }
                    }}
                    variant="contained"
                    color="secondary"
                >
                    Upgrade Now
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BatchCommentLimitDialog;